/* eslint-disable hum/restrict-entities-imports */
/* eslint-disable hum/require-model-import */
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { PeriodResolution } from "@/features/Metrics/Metrics.types";

export enum WindowOperation {
    AVERAGE = "a",
    SUM = "s",
    LATEST = "l",
    DELTA = "d",
    COMPLETE_AVERAGE = "ca",
    COMPLETE_SUM = "cs",
}

export enum WindowType {
    APPLY_BEFORE = "w",
    APPLY_AFTER = "W",
}

export const ResolutionMap = new Map<string, PeriodResolution>([
    ["m", PeriodResolution.MONTHLY],
    ["q", PeriodResolution.QUARTERLY],
    ["y", PeriodResolution.YEARLY],
]);

export class MetricQueryString {
    accountLabel: AccountLabel;
    resolution: PeriodResolution;
    windowSize?: number;
    windowOperation?: WindowOperation;
    windowType?: WindowType;

    constructor(accountLabel: AccountLabel) {
        this.accountLabel = accountLabel;
        this.resolution = PeriodResolution.MONTHLY;
    }

    monthly(): this {
        this.resolution = PeriodResolution.MONTHLY;
        return this;
    }

    quarterly(): this {
        this.resolution = PeriodResolution.QUARTERLY;
        return this;
    }

    yearly(): this {
        this.resolution = PeriodResolution.YEARLY;
        return this;
    }

    applyBefore(): this {
        this.windowType = WindowType.APPLY_BEFORE;
        return this;
    }

    applyAfter(): this {
        this.windowType = WindowType.APPLY_AFTER;
        return this;
    }

    applyBeforeIf(condition: boolean): this {
        return condition ? this.applyBefore() : this.applyAfter();
    }

    applyAfterIf(condition: boolean): this {
        return condition ? this.applyAfter() : this.applyBefore();
    }

    window(windowSize: number): this {
        this.windowSize = windowSize;
        return this;
    }

    average(): this {
        this.windowOperation = WindowOperation.AVERAGE;
        return this;
    }

    sum(): this {
        this.windowOperation = WindowOperation.SUM;
        return this;
    }

    latest(): this {
        this.windowOperation = WindowOperation.LATEST;
        return this;
    }

    delta(): this {
        this.windowOperation = WindowOperation.DELTA;
        return this;
    }

    completeAverage(): this {
        this.windowOperation = WindowOperation.COMPLETE_AVERAGE;
        return this;
    }

    completeSum(): this {
        this.windowOperation = WindowOperation.COMPLETE_SUM;
        return this;
    }

    hasWindow(): boolean {
        return (
            this.windowType !== undefined &&
            this.windowSize !== undefined &&
            this.windowOperation !== undefined
        );
    }

    toString(): string {
        const resolutionLetter =
            this.resolution === PeriodResolution.MONTHLY
                ? "m"
                : this.resolution === PeriodResolution.QUARTERLY
                  ? "q"
                  : "y";

        let query = `${this.accountLabel}-${resolutionLetter}`;

        if (this.hasWindow()) {
            query += `-${this.windowType}${this.windowSize}${this.windowOperation}`;
        }

        return query;
    }
}
